var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15.8332H5.33333L12.5208 8.64567L11.3542 7.479L4.16667 14.6665V15.8332ZM16.0833 7.43734L12.5417 3.93734L13.7083 2.77067C14.0278 2.45123 14.4201 2.2915 14.8854 2.2915C15.3507 2.2915 15.7431 2.45123 16.0625 2.77067L17.2292 3.93734C17.5486 4.25678 17.7153 4.6422 17.7292 5.09359C17.7431 5.54498 17.5903 5.93039 17.2708 6.24984L16.0833 7.43734ZM3.33333 17.4998C3.09722 17.4998 2.89931 17.42 2.73958 17.2603C2.57986 17.1005 2.5 16.9026 2.5 16.6665V14.3123C2.5 14.2012 2.52083 14.0936 2.5625 13.9894C2.60417 13.8853 2.66667 13.7915 2.75 13.7082L11.3333 5.12484L14.875 8.6665L6.29167 17.2498C6.20833 17.3332 6.11458 17.3957 6.01042 17.4373C5.90625 17.479 5.79861 17.4998 5.6875 17.4998H3.33333Z",
    fill: "#6E6D92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcons);
export default __webpack_public_path__ + "static/media/editIcons.b5bebde4e165225175a7ebafdd955011.svg";
export { ForwardRef as ReactComponent };